package com.parmartechnologies.commerce.feature.inventory.viewModel.inventory

import com.parmartechnologies.core.feature.currency.model.Currency
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.feature.inventory.inventory.network.CreateInventoryRequest
import com.parmartechnologies.core.feature.inventory.inventory.network.DeleteInventoryRequest
import com.parmartechnologies.core.feature.inventory.inventory.network.RetrieveInventoryRequest
import com.parmartechnologies.core.feature.inventory.inventory.network.UpdateInventoryRequest
import com.parmartechnologies.core.feature.product.model.ProductPrice
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.inventory.handler.InventoryHandler
import com.parmartechnologies.commerce.feature.inventory.network.inventory.InventoryNetwork
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.storage.table.inventory.InventoryDatabaseTable
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

class InventoryViewModel(val business: Business) : AppViewModel() {
    val repository = InventoryHandler.shared().repository
    val searchQuery: StateFlow<String>
        get() = repository.searchQuery
    val allInventory: StateFlow<List<Inventory>>
        get() = repository.allInventory
    val productInventory: StateFlow<List<Inventory>>
        get() = repository.productInventory
    val lowestPriceProduct: StateFlow<Inventory?>
        get() = repository.lowestPriceProduct
    val highestPriceProduct: StateFlow<Inventory?>
        get() = repository.highestPriceProduct
    val allBarcodes: StateFlow<List<Inventory>>
        get() = repository.allInventory
    override fun changeSearchQuery(value: String) {
        scope.launch {
            repository.searchQueryState.emit(value)
        }
    }

    fun searchQuery(value: String, param: NavigationParam?) {
        InventoryDatabaseTable().search(value, param) { filteredItems ->
            scope.launch {
                repository.productInventoryState.emit(filteredItems)
            }
        }
    }
    fun clearSearchQuery(){
        scope.launch {
            repository.searchQueryState.emit("")
        }
    }


    @OptIn(ExperimentalTime::class)
    fun createInventory(
        name: String,
        description: String,
        productId: String,
        categoryId: String,
        subCategoryId: String,
        model: String,
        Barcode: String,
        brandId: String,
        tagId: String,
        uomId: String,
        colorId: String,
        qty: Long,
        sizeId: String,
        discountId: String,
        couponId: String,
        costPrice: Double,
        mrp: Double,
        discount: Double,
        price: Double,
        salePrice: Double,
        finalPrice: Double,
        cgst: Double,
        sgst: Double,
        igst: Double,
        currency: Currency,
        taxIncluded: Int,
        totalTax: Double,
        callBack: (Boolean) -> Unit
    ) {
        val productPrice = ProductPrice(
            CostPrice = costPrice,
            Price = price,
            SalePrice = salePrice,
            MRP = mrp,
            FinalPrice = finalPrice,
            SGST = sgst,
            CGST = cgst,
            IGST = igst,
            Discount = discount,
            currency = currency,
            taxIncluded = taxIncluded,
            Tax= totalTax
        )

        val request = CreateInventoryRequest(
            Clock.System.now().epochSeconds,
            AuthHandler.shared().UserID,
            business._id,
            "",
            categoryID = categoryId,
            subCategoryID = subCategoryId,
            name,
            description,
            productID = productId,
            productPrice = productPrice,
            model,
            Barcode,
            brandID = brandId,
            tagID = tagId,
            uomID = uomId,
            colorID = colorId,
            qty,
            sizeID = sizeId,
            discountID = discountId,
            CouponID = couponId
        )
        startLoading()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            InventoryNetwork().create(request) {
                stopLoading()
                if (!it?.payload?._id.isNullOrEmpty()) {
                    InventoryDatabaseTable().insert(it?.payload)
                    callBack(true)
                } else {
                    callBack(false)
                }
            }
        }
    }

    @OptIn(ExperimentalTime::class)
    fun updateInventory(
        _id: String,
        inventoryID: Long,
        name: String,
        description: String,
        productId: String,
        categoryId: String,
        subCategoryId: String,
        model: String,
        Barcode: String,
        brandId: String,
        tagId: String,
        uomId: String,
        colorId: String,
        qty: Long,
        sizeId: String,
        discountId: String,
        couponId: String,
        costPrice: Double,
        mrp: Double,
        discount: Double,
        price: Double,
        salePrice: Double,
        finalPrice: Double,
        cgst: Double,
        sgst: Double,
        igst: Double,
        currency: Currency,
        taxIncluded: Int,
        totalTax: Double,
        callBack: (Boolean) -> Unit
    ) {
        val productPrice = ProductPrice(
            CostPrice = costPrice,
            SalePrice = salePrice,
            Price = price,
            MRP = mrp,
            FinalPrice = finalPrice,
            SGST = sgst,
            CGST = cgst,
            IGST = igst,
            Discount = discount,
            currency = currency,
            taxIncluded=taxIncluded,
            Tax = totalTax
        )
        val request = UpdateInventoryRequest(
            _id = _id,
            inventoryID,
            AuthHandler.shared().UserID,
            business._id,
            "",
            categoryID = categoryId,
            subCategoryID = subCategoryId,
            name,
            description,
            productID = productId,
            productPrice = productPrice,
            model,
            Barcode,
            brandID = brandId,
            tagID = tagId,
            uomID = uomId,
            colorID = colorId,
            qty,
            sizeID = sizeId,
            discountID = discountId,
            couponID = couponId
        )
        startLoading()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            InventoryNetwork().update(request) {
                stopLoading()
                InventoryDatabaseTable().update(it?.payload) {
                    callBack(it?.payload != null)
                }
            }
        }
    }

    fun deleteInventory(Id: String, callBack: (Boolean) -> Unit) {
        val request = DeleteInventoryRequest(
            _id = Id,
        )
        startLoading()
        scope.launch {
            InventoryNetwork().delete(request) {
                stopLoading()
                if (it?.status?.equals("SUCCESS") == true) {
                    callBack(true)
                } else {
                    callBack(false)
                }
            }
        }
    }

    fun loadInventory(param: NavigationParam?) {
        loadFromStorage(param)
        InventoryDatabaseTable().LastSyncDate(param) { date ->
            val request = RetrieveInventoryRequest(
                business._id,
                date ?: ""
            )
            startLoading()
            InventoryNetwork().retrieve(request) {
                InventoryDatabaseTable().insert(it?.payload) {
                    stopLoading()
                    loadFromStorage(param)
                }
            }
        }
    }

    fun loadInventoryForBusiness(id: String) {
        loadInventoryForBusinessFromStorage(id)
//        startLoading()
        InventoryDatabaseTable().LastSyncDate(id) { date ->
            val request = RetrieveInventoryRequest(
                id,
                date ?: ""
            )
            InventoryNetwork().retrieve(request) {
                InventoryDatabaseTable().insert(it?.payload) {

                }
                scope.launch {
//                    stopLoading()
                    delay(500)
                    loadInventoryForBusinessFromStorage(id)
                }
            }
        }
    }

    fun loadProductInventory(param: NavigationParam?) {
        //loadProductInventoryFromStorage(param)
        InventoryDatabaseTable().LastSyncDate(param) { date ->
            val request = RetrieveInventoryRequest(
                business._id,
                date ?: ""
            )
            startLoading()
            InventoryNetwork().retrieve(request) {
                InventoryDatabaseTable().insert(it?.payload) {
                    stopLoading()
                    loadProductInventoryFromStorage(param)
                }
            }
        }
    }

    private fun loadFromStorage(param: NavigationParam?) {
        if (!param?.business?._id.isNullOrEmpty()) {
            InventoryDatabaseTable().retrieve(param.business._id) { data ->
                mainScope.launch {
                    repository.allInventoryState.emit(data)
//                    val minInventory: Inventory = data.minBy { it.ProductPrice.FinalPrice!! }
//                    val maxInventory: Inventory = data.maxBy { it.ProductPrice.FinalPrice!! }
//                    repository.minPriceProductState.emit(minInventory)
//                    repository.maxPriceProductState.emit(maxInventory)
                }
            }
        } else {
            mainScope.launch {
                repository.allInventoryState.emit(arrayListOf())
            }
        }

    }

    private fun loadInventoryForBusinessFromStorage(id: String) {
        InventoryDatabaseTable().retrieve(id) { data ->
            scope.launch {
                repository.allInventoryState.emit(data)
            }
        }
    }

    private fun  loadProductInventoryFromStorage(param: NavigationParam?) {
        scope.launch {
            repository.productInventoryState.emit(arrayListOf())
        }
        if (param?.product?._id != "") {
            InventoryDatabaseTable().retrieveAll(param?.product?._id.toString()) { data ->
                scope.launch {
                    repository.productInventoryState.emit(data)
                    val lowestProduct: Inventory? =
                        data.minByOrNull { it.ProductPrice?.FinalPrice!! }
                    val highestProduct: Inventory? =
                        data.maxByOrNull { it.ProductPrice?.FinalPrice!! }
                    repository.lowestPriceProductState.emit(lowestProduct)
                    repository.highestPriceProductState.emit(highestProduct)
                }
            }
        } else {
            scope.launch {
                repository.productInventoryState.emit(arrayListOf())
            }
        }
    }

    fun findById(
        colorId: String,
        sizeId: String,
        uomId: String,
        param: NavigationParam?,
        callBack: (List<Inventory>) -> Unit
    ) {
        if (colorId != "" && sizeId != "" && uomId != "") {
            InventoryDatabaseTable().findByColorIdAndSizeIdAndUOMId(
                colorId,
                sizeId,
                uomId,
                param
            ) { filteredItems ->
                callBack(filteredItems)
            }
        } else if (sizeId != "" && uomId != "") {
            InventoryDatabaseTable().findBySizeIdAndUOMId(sizeId, uomId, param) { filteredItems ->
                callBack(filteredItems)
            }
        } else if (colorId != "" && uomId != "") {
            InventoryDatabaseTable().findByColorIdAndUOMId(colorId, uomId, param) { filteredItems ->
                callBack(filteredItems)
            }
        } else if (colorId != "" && sizeId != "") {
            InventoryDatabaseTable().findByColorIdAndSizeId(
                colorId,
                sizeId,
                param
            ) { filteredItems ->
                callBack(filteredItems)
            }
        } else if (uomId != "") {
            InventoryDatabaseTable().findByUOMId(uomId, param) { filteredItems ->
                callBack(filteredItems)
            }
        } else if (sizeId != "") {
            InventoryDatabaseTable().findBySizeId(sizeId, param) { filteredItems ->
                callBack(filteredItems)
            }
        } else if (colorId != "") {
            InventoryDatabaseTable().findByColorId(colorId, param) { filteredItems ->
                callBack(filteredItems)
            }
        } else {
            if (param != null) {
                InventoryDatabaseTable().retrieveAll(
                    param.product._id
                ) { filteredItems ->
                    callBack(filteredItems)
                }
            }
        }
    }

}
